// extracted by mini-css-extract-plugin
module.exports = {"content":"yourMemories_content__39U6y","title":"yourMemories_title__3FLWN","subTitle":"yourMemories_subTitle__xUkrQ","textFirst":"yourMemories_textFirst__1e0PE","textSecond":"yourMemories_textSecond__1K9sk","textThrid":"yourMemories_textThrid__trPXA","contentImage":"yourMemories_contentImage__2vcDL","image":"yourMemories_image__2Dysh","container":"yourMemories_container__2RnYj"};
    if(module.hot) {
      // 1783592031559
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  